module.exports = __webpack_public_path__ + "media/images/app/products/index/categories/rings-f72335d76274309a3daa754ef49bc3c0.webp";